<template>
  <rich-button @click="commands.heading({ level: 3 })" v-bind:isActive="isActive.heading({ level: 3 })" v-bind:icon="'h3'" />
</template>

<script>
  import H3Button from './H3Button.ts'
  export default H3Button
</script>
